import { Inject, Injectable } from '@angular/core';
import { filter, map, Observable, switchMap, take } from 'rxjs';
import { SessionService } from '../services/session.service';
import { WINDOW } from '@sfcu/sfc-front-starter';
import { HostnameService } from '../services/hostname.service';

@Injectable({
    providedIn: 'root'
})
export class SuiviGuard {
    constructor(private sessionService: SessionService,
                @Inject(WINDOW) private window: Window,
                private hostnameService: HostnameService) {
    }

    canActivate(): Observable<boolean> {
        return this.sessionService.isUserDataLoaded().pipe(
            filter(loaded => loaded),
            take(1),
            switchMap(() => this.sessionService.getUserData()),
            take(1),
            map(userData => {
                if (userData.isMobileResilie && userData.isBox5G) {
                    if (userData.isMobileAbonneSfr) {
                        this.window.location?.replace(this.hostnameService.espaceClientBaseUrl() + 'suivre-ma-commande/authentification');
                        return false;
                    } else if (userData.isMobileAbonneRed) {
                        this.window.location?.replace(this.hostnameService.espaceClientBaseUrl('red') + 'suivre-ma-commande/authentification');
                        return false;
                    }
                    return true
                }
                return true;
            })
        );
    }
}
